export const PHOTO_REPORT_LETTERHEAD_KEYS = {
  all: () => ["photoReportLetterhead"] as const,
  estimate: (estimateId: string) => [...PHOTO_REPORT_LETTERHEAD_KEYS.all(), "estimate", estimateId] as const,
};
